var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.482 15L9.48199 12M12.482 15C13.8788 14.4687 15.2189 13.7987 16.482 13M12.482 15V20C12.482 20 15.512 19.45 16.482 18C17.562 16.38 16.482 13 16.482 13M9.48199 12C10.0141 10.6194 10.6842 9.29607 11.482 8.05C12.6472 6.18699 14.2696 4.65305 16.195 3.5941C18.1204 2.53514 20.2847 1.98637 22.482 2C22.482 4.72 21.702 9.5 16.482 13M9.48199 12H4.48199C4.48199 12 5.03199 8.97 6.48199 8C8.10199 6.92 11.482 8 11.482 8M4.98199 16.5C3.48199 17.76 2.98199 21.5 2.98199 21.5C2.98199 21.5 6.72199 21 7.98199 19.5C8.69199 18.66 8.68199 17.37 7.89199 16.59C7.5033 16.219 6.99129 16.0046 6.45422 15.988C5.91715 15.9714 5.39287 16.1537 4.98199 16.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketHover);
export default __webpack_public_path__ + "static/media/rocketHover.b2b9ccc4562489c3710e11b943486c77.svg";
export { ForwardRef as ReactComponent };